import Tokens from '../styles/Tokens';
const DragNDropStyles = {
    getPrimaryDraggable(isDragging, draggableStyle) {
        return (Object.assign({ backgroundColor: isDragging ? Tokens.colorCtaBlueTint : Tokens.colorBrandNeutral100, border: isDragging ? `solid ${Tokens.borderWidthThick} ${Tokens.colorCtaBlueBase}`
                : `solid ${Tokens.borderWidthThin} ${Tokens.colorBrandNeutral400}`, userSelect: 'none' }, draggableStyle));
    },
    getPrimaryDroppable(isDraggingOver) {
        return ({
            backgroundColor: isDraggingOver ? Tokens.colorBrandNeutral300 : Tokens.colorBrandNeutral100,
            borderRadius: Tokens.spacing20,
            padding: Tokens.spacing30,
            width: Tokens.widthFluid
        });
    },
    getPrimaryNoBorderDraggable(isDragging, draggableStyle) {
        return (Object.assign({ backgroundColor: isDragging ? Tokens.colorCtaBlueTint : Tokens.colorBrandNeutral100, border: isDragging ? `solid ${Tokens.borderWidthThick} ${Tokens.colorCtaBlueBase}` : 'none', userSelect: 'none' }, draggableStyle));
    },
    getSecondaryDraggable(isDragging, draggableStyle) {
        return (Object.assign({ backgroundColor: isDragging ? Tokens.colorCtaBlueTint : Tokens.colorCtaBlueTint, border: isDragging ? `solid ${Tokens.borderWidthThick} ${Tokens.colorCtaBlueBase}`
                : `solid ${Tokens.borderWidthThin} ${Tokens.colorCtaBlueBase}`, userSelect: 'none' }, draggableStyle));
    },
    getSecondaryDroppable(isDraggingOver) {
        return ({
            backgroundColor: isDraggingOver ? Tokens.colorBrandNeutral300 : Tokens.colorBrandNeutral100,
            borderTop: `solid ${Tokens.borderWidthThin} ${Tokens.colorBrandNeutral400}`,
            padding: Tokens.spacing40,
            width: Tokens.widthFluid
        });
    }
};
export default DragNDropStyles;
